import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { WorkoutPlanScannerPage } from './workout-plan-scanner-page';
import { PagesModule } from 'pages/pages.module';

@NgModule({
  declarations: [WorkoutPlanScannerPage],
  imports: [PagesModule, ComponentsModule, DirectivesModule],
})
export class WorkoutPlanScannerPageModule { }
